import React from "react";
import NewsletterForm from "./components/NewsletterForm.jsx";
import PrintSubscriptionForm from "./components/PrintSubscriptionForm.jsx";
import "./App.css";
import RedirectPage from "./components/Redirect.jsx";

function App() {
  return (
    <>
      <RedirectPage />
    </>
  );
}

export default App;
